import type { Subscription } from '../../types';
import { isInvoiced as isLegacySubscriptionInvoiced } from '../legacySubscription/isInvoiced';
import { isInvoiced as isModernSubscriptionInvoiced } from '../modernSubscription/isInvoiced';

import { isModernSubscription } from './isModernSubscription';

export function isInvoiced(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernSubscriptionInvoiced(subscription);
  }

  return isLegacySubscriptionInvoiced(subscription);
}
